<template>
  <div>
    <!-- 匹配订单护照页-->
    <el-dialog :visible.sync="visible" width="419px" class="quan-dialog-out-class" :close-on-click-modal="true">
      <div class="dialog-member-title">
        <span class="dialog-member-name">上传护照页</span>
        <div class="dialog-close" @click="closeFn">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div style="padding: 20px;min-height: 200px; max-height: 60vh; overflow-y: auto;">
        <el-upload list-type="picture" action="*" :http-request="uploadSelectionpage" :on-remove="handleSelectionRemove" :before-remove="beforeSelectionRemove" multiple :file-list="selectionFileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>

      </div>
      <div class="packge-btn-add">
        <el-button class="pageck-btn" @click="closeFn">关闭</el-button>
        <el-button class="pageck-btn default" type="primary" @click="submitSelectionUpload" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import alyoss from "@/utils/alyoss2";
import {
  orderimportpassport
} from "@/api/order.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectionRow: {
        type: Array,
        default: []
    }
    
  },
  data() {
    return {
      selectionFileList: [],
      loading:false
    }
  },
  watch:{
    selectionFileList: {
        handler(newVal, oldVal) {
          let flag = false;
          for(let i = 0; i < newVal.length; i++) {
            if(!newVal[i].url) {
              flag = true;
            }
          } 
          this.loading = flag;
        },
        deep: true,
        immediate: true
    }
  },
  methods: {
    submitSelectionUpload() {
      console.log('file', this.selectionRow, this.selectionFileList);
      let ids = this.selectionRow.map(res => res.id);
      let images = this.selectionFileList.map(res => res.url);
      this.loading = true;
      orderimportpassport({ids, images}).then(() => {
        this.$message.success('操作成功')
        this.selectionFileList = [];
        this.closeFn();
        this.loading = false;
      })
    },
    async uploadSelectionpage(file) {
      this.loading = true;
      this.selectionFileList.push({uid: file.file.uid, url:file.file.url, status: 'warning'});
      await alyoss(file.file).then(alyossData => {
        console.log(alyossData);
        
        let findIndex = this.selectionFileList.findIndex(res => res.uid == file.file.uid)
        this.selectionFileList[findIndex].url = alyossData;
        this.selectionFileList = [...this.selectionFileList];
      });
    },
    beforeSelectionRemove(file, fileList) {
      return this.$confirm(`是否确定移除？`);
    },
    handleSelectionRemove(file, fileList) {
      let findIndex = this.selectionFileList.findIndex(res => res.uid == file.uid)
      this.selectionFileList.splice(findIndex, 1)
    },
    closeFn() {
        if (this.selectionFileList.length) {
            this.$confirm('关闭弹窗后会清空所有数据，是否关闭?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.selectionFileList = []
                this.$emit('close')
            })
        } else {
            this.selectionFileList = []
            this.$emit('close')
        }
    }
  }

}
</script>

<style>
</style>